module.exports = __webpack_public_path__ + "img/ico_biaoqianziyuan.0a2729e7.png";